'use client';

import type { InterventionSession } from '@/lib/storage';

interface Props {
  sessions: InterventionSession[];
  streak: number;
  avg: number;
}

export default function QuickStats({ sessions, streak, avg }: Props) {
  if (sessions.length === 0) return null;

  return (
    <div className="grid grid-cols-3 gap-3">
      <div className="bg-[hsl(var(--card))] rounded-2xl p-3 text-center border border-[hsl(var(--border))]">
        <p className="text-xl font-bold text-[hsl(var(--foreground))] font-tabular">{sessions.length}</p>
        <p className="text-[10px] text-[hsl(var(--muted-foreground))] mt-0.5 leading-tight">Sesji łącznie</p>
      </div>
      <div className="bg-[hsl(var(--card))] rounded-2xl p-3 text-center border border-[hsl(var(--border))]">
        <p className="text-xl font-bold text-[hsl(38_90%_62%)] font-tabular">
          {streak > 0 ? `${streak}🔥` : '—'}
        </p>
        <p className="text-[10px] text-[hsl(var(--muted-foreground))] mt-0.5 leading-tight">Passeria dni</p>
      </div>
      <div className="bg-[hsl(var(--card))] rounded-2xl p-3 text-center border border-[hsl(var(--border))]">
        <p className="text-xl font-bold text-[hsl(var(--primary))] font-tabular">
          {avg > 0 ? avg.toFixed(1) : '—'}
        </p>
        <p className="text-[10px] text-[hsl(var(--muted-foreground))] mt-0.5 leading-tight">Śr. ocena</p>
      </div>
    </div>
  );
}